import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
//import { Navigation } from "./Navigation";
import { AccountMenu } from "./Component/AccountMenu";
import "../node_modules/video-react/dist/video-react.css";
import "./Component/Asset.css";
import { Grid } from "@mui/material";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { Button } from "@mui/material";
import { TextField } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { API_DOMAIN_URL } from "./Common";

export function ForgotPassword() {
  const [formStatus, setFormStatus] = useState(0);

  const validationSchema = Yup.object().shape({
    MailAddress: Yup.string()
      .required("E-mailを入力してください")
      .email("E-mailが無効です"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  // フォームに入力されたデータをチェックして
  // 確認画面へ遷移
  const onSubmit = (data) => {
    if (data.MailAddress == undefined) {
      console.log("Invalid Input Value");
      return;
    }

    // トークン発行とメール送信
    sendData(data.MailAddress);
  };

  const sendData = (mailAddress) => {
    if (!mailAddress) {
      return;
    }

    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/CreatePasswordResetToken?code=${code}&MailAddress=${mailAddress}`;
    //console.log(url);
    fetch(url).then(
      function (response) {
        //console.log(response);
        if (response.status == 200) {
          setFormStatus(1);
        } else if (
          response.status == 204 ||
          response.status == 400 ||
          response.status == 500
        ) {
          errorModalOpen();
        }
      },
      function (error) {
        console.log(error);
      }
    );
  };

  const inputFrom = (
    <Box
      component="form"
      noValidate
      onSubmit={handleSubmit(onSubmit)}
      sx={{
        marginTop: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Typography component="h1" variant="h5">
        パスワード再設定
      </Typography>

      <Grid
        container
        direction="columun"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid
          item
          md={12}
          container
          direction="row"
          justifyContent="center"
          alignItems="flex-start"
          sx={{ p: "10px" }}
        >
          <Grid item md={12}>
            <Typography variant="body2">
              パスワード再発行の手続きを行います。
            </Typography>
            <Typography variant="body2">
              登録時のメールアドレスを入力してください。
            </Typography>
          </Grid>
          <Grid item md={12} mt={1}>
            <TextField
              required
              size="small"
              fullWidth
              name="MailAddress"
              label="E-mail"
              type="email"
              id="MailAddress"
              {...register("MailAddress")}
              error={errors.MailAddress ? true : false}
            />
            <Typography variant="inherit" color="textSecondary">
              {errors.MailAddress?.message}
            </Typography>
          </Grid>
          <Grid item md={10}></Grid>
          <Grid item md={2}>
            <Button
              variant="contained"
              color="primary"
              sx={{ mt: 2, pl: "20px", pr: "20px", pt: "10px", pb: "10px" }}
              align
              type="submit"
            >
              メール送信
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );

  const sentEmail = (
    <Box
      noValidate
      sx={{
        marginTop: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Typography component="h1" variant="h5">
        メール送信完了
      </Typography>

      <Grid
        container
        direction="columun"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid
          item
          md={12}
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          sx={{ p: "10px" }}
        >
          <Grid item md={12} alignItems="center">
            <Typography variant="body2" textAlign="center">
              パスワード再設定用のメールを送信しました。
            </Typography>
            <Typography variant="body2" textAlign="center">
              メールボックスを確認し、パスワードを再設定してください。
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );

  // エラーモーダル
  const [open, setOpen] = React.useState(false);
  const errorModalOpen = () => {
    setOpen(true);
  };
  const errorModalClose = () => {
    setOpen(false);
  };

  return (
    <div className="asset-list-root">
      <AccountMenu />
      <Container component="main" maxWidth="md">
        <CssBaseline />
        {formStatus == 0 ? inputFrom : sentEmail}
      </Container>
      <Dialog
        open={open}
        onClose={errorModalClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">メール送信エラー</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            パスワード再設定のメール送信に失敗しました。
            <br />
            メールアドレスが正しいか確認してください。
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={errorModalClose}>OK</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
